// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"787445b5","569":"af402b37","966":"5b26bcff"}[chunkId] + ".chunk.js";
};